import { useCallback } from 'react';

/**
 * Returns memoized function that prefixes field names.
 * @param prefix Name to prefix field names with
 */
export function useFormPrefix(prefix?: string | null): (name: string) => string {
  return useCallback(name => [prefix, name].filter(x => !!x).join('.'), [prefix]);
}
